import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  promotions: [],
  promotion: {},
};

export const promotionSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    setPromotions: (state, action) => {
      state.promotions = action.payload;
    },
    setPromotion: (state, action) => {
      state.promotion = action.payload.promotion;
    },
  },
});

export const { setPromotions, setPromotion } = promotionSlice.actions;

export default promotionSlice.reducer;
